import { Box } from '@mui/material'
import { styled } from '@mui/system'

/* 做一个Widget Wrapper样式组件, 设定padding, 背景颜色, 圆角 */
const WidgetWrapper = styled(Box)(({ theme }) => ({
  padding: '1.5rem 1.5rem 0.75rem 1.5rem',
  backgroundColor: theme.palette.background.alt,
  borderRadius: '0.75rem',
}))

export default WidgetWrapper
